/* src/app/home-page/image-header/image-header.component.scss */
:root {
  --var-color-dark-blue: #1b394e;
  --var-color-blue: #004b87;
  --var-color-black: #353739;
  --var-color-dark-grey: #757575;
  --var-color-medium-grey: #b5b5b5;
  --var-color-mid-grey: #d8d8d8;
  --var-color-light-grey: #f3f3f3;
  --var-color-white: #ffffff;
}
:root {
  --var-color-blue-100: #2d96cd;
  --var-color-green-100: #4caf50;
  --var-color-yellow-100: #fdd835;
  --var-color-red-100: #b71c1c;
}
:root {
  --var-color-blue-150: #1c6890;
  --var-color-blue-125: #1376aa;
  --var-color-blue-75: #61b0d9;
  --var-color-blue-50: #93c7e3;
  --var-color-blue-25: #c6e1ee;
  --var-color-red-75: #c85454;
  --var-color-red-50: #d88a8a;
  --var-color-red-25: #ffebee;
  --var-color-yellow-125: #fbc02d;
  --var-color-yellow-75: #fde167;
  --var-color-yellow-50: #fbe897;
  --var-color-yellow-25: #f9f1c8;
  --var-color-green-150: #2f8132;
  --var-color-green-125: #419a45;
  --var-color-green-75: #78c27b;
  --var-color-green-50: #a2d4a4;
  --var-color-green-25: #cee7cf;
}
:root {
  --var-color-radio-button-dot: #3984B7;
  --var-disabled-label-color: #D8D8D8;
  --var-primary-button-background-color: #2683B4;
  --var-primary-button-border-color: #2683B4;
  --var-primary-button-label-color: #FFFFFF;
  --var-primary-button-focus-background-color: #1C6890;
  --var-primary-button-focus-border-color: #FFFFFF;
  --var-primary-button-focus-label-color: #FFFFFF;
  --var-primary-button-hover-state-background-color: #2B658C;
  --var-primary-button-disabled-state-background-color: #F3F3F3;
  --var-primary-button-disabled-state-border-color: #E9E9E9;
  --var-primary-button-disabled-state-label-color: #D8D8D8;
  --var-secondary-button-label-color: #3984B7;
  --var-secondary-button-border-color: #3984B7;
  --var-secondary-button-background-color: #FFFFFF;
  --var-secondary-button-focus-label-color: #FFFFFF;
  --var-secondary-button-focus-border-color: #FFFFFF;
  --var-secondary-button-focus-background-color: #3984B7;
  --var-secondary-button-hover-state-background-color: #3984b8;
  --var-secondary-button-hover-label-color: #FFFFFF;
  --var-secondary-button-disabled-state-background-color: #FFFFFF;
  --var-secondary-button-disabled-state-border-color: #B5B5B5;
  --var-secondary-button-disabled-state-label-color: #D8D8D8;
  --var-tertiary-button-background-color: transparent;
  --var-tertiary-button-border-color: transparent;
  --var-tertiary-button-label-color: #3984b8;
  --var-tertiary-button-focus-background-color: transparent;
  --var-tertiary-button-focus-border-color: #8CC0FD;
  --var-tertiary-button-focus-label-color: #2D4254;
  --var-tertiary-button-hover-state-background-color: transparent;
  --var-tertiary-button-hover-label-color: #2D4254;
  --var-tertiary-button-disabled-state-background-color: transparent;
  --var-tertiary-button-disabled-state-border-color: transparent;
  --var-tertiary-button-disabled-state-label-color: #D8D8D8;
  --var-tertiary-button-visited-label-color: #4B9FAD;
  --var-cancel-button-background-color: #C31120;
  --var-cancel-button-border-color: #C31120;
  --var-cancel-button-label-color: #FFFFFF;
  --var-cancel-button-focus-background-color: #C31120;
  --var-cancel-button-focus-border-color: #FFFFFF;
  --var-cancel-button-focus-label-color: #FFFFFF;
  --var-cancel-button-disabled-state-background-color: #F3F3F3;
  --var-cancel-button-disabled-state-border-color: #F3F3F3;
  --var-cancel-button-disabled-state-label-color: #D8D8D8;
  --var-cancel-button-hover-state-background-color: #711119;
  --var-action-button-background-color: #1376AA;
  --var-action-button-border-color: #1376AA;
  --var-action-button-label-color: #FFFFFF;
  --var-action-button-focus-background-color: #1C6890;
  --var-action-button-focus-border-color: #FFFFFF;
  --var-action-button-focus-label-color: #FFFFFF;
  --var-action-button-hover-state-background-color: #2B658C;
  --var-action-button-disabled-state-background-color: #F3F3F3;
  --var-action-button-disabled-state-border-color: #E9E9E9;
  --var-action-button-disabled-state-label-color: #D8D8D8;
  --var-action-button-success-background-color: #2F8132;
  --var-action-button-failed-background-color: #B71C1C;
}
:root {
  --var-color-header-bottom-border: #DCDEE2;
}
:root {
  --var-color-icon-enabled: #2C96CE;
  --var-color-icon-disabled: #B5B5B5;
}
:root {
  --var-color-hamburger_menu-bkgr: #FFFFFF;
  --var-color-hamburger-patty: #000000;
  --var-color-hamburger-active: #FFFFFF;
  --var-color-wide-menu-header-bkgr: #146097;
  --var-color-wide-menu-bkgr: #FFFFFF;
  --var-color-wide-menu-active: #004B87;
  --var-color-wide-sub-menu-hdr-bkgr: #F3F3F3;
  --var-color-wide-sub-menu-hdr-text: #000000;
  --var-color-wide-sub-menu-link-bkgr: #FFFFFF;
  --var-color-wide-sub-menu-link-text: #000000;
  --var-color-wide-sub-menu-link-hover: #4189BA;
  --var-color-wide-sub-menu-link-hover-bkgr: #AEAEAE;
  --var-color-wide-sub-menu-link-disabled: #B5B5B5;
}
:root {
  --var-color-active-accordion-bkgr: #2683B4;
  --var-color-dflt-accordion-bkgr: #ffb300;
  --var-color-anchor-accordion: #353739;
  --var-color-brdr-accordion-clr: #B5B5B5;
}
:root {
  --var-color-active-paginator-bkgr: #3984B7;
}
:root {
  --var-color-alert-icon-success: #4caf50;
  --var-color-alert-bkgr-success: #cee7cf;
  --var-color-alert-icon-error: #b71c1c;
  --var-color-alert-bkgr-error: #fac7c8;
  --var-color-alert-icon-warn: #fbc02d;
  --var-color-alert-bkgr-warn: #f9f1c8;
  --var-color-alert-icon-info: #2d96cd;
  --var-color-alert-bkgr-info: #c6e1ee;
}
:root {
  --var-color-footer-text: #ffffff;
  --var-color-footer-bkgr: #353739;
}
:root {
  --var-color-surface: #f3f3f3;
  --var-color-shadow: rgba(0, 0, 0, 0.3);
}
:root {
  --var-color-tooltip-text: #ffffff;
  --var-color-tooltip-bkgr: #56585a;
  --var-color-tooltip-icon: #2D96CD;
}
:root {
  --var-color-field-header-text: #757575;
  --var-color-field-data-text: #242D31;
}
:root {
  --var-color-dark-blue: #1b394e;
  --var-color-blue: #004b87;
  --var-color-black: #353739;
  --var-color-dark-grey: #757575;
  --var-color-medium-grey: #b5b5b5;
  --var-color-mid-grey: #d8d8d8;
  --var-color-light-grey: #f3f3f3;
  --var-color-white: #ffffff;
}
:root {
  --var-color-blue-100: #2d96cd;
  --var-color-green-100: #4caf50;
  --var-color-yellow-100: #fdd835;
  --var-color-red-100: #b71c1c;
}
:root {
  --var-color-blue-150: #1c6890;
  --var-color-blue-125: #1376aa;
  --var-color-blue-75: #61b0d9;
  --var-color-blue-50: #93c7e3;
  --var-color-blue-25: #c6e1ee;
  --var-color-red-75: #c85454;
  --var-color-red-50: #d88a8a;
  --var-color-red-25: #ffebee;
  --var-color-yellow-125: #fbc02d;
  --var-color-yellow-75: #fde167;
  --var-color-yellow-50: #fbe897;
  --var-color-yellow-25: #f9f1c8;
  --var-color-green-150: #2f8132;
  --var-color-green-125: #419a45;
  --var-color-green-75: #78c27b;
  --var-color-green-50: #a2d4a4;
  --var-color-green-25: #cee7cf;
}
:root {
  --var-color-radio-button-dot: #3984B7;
  --var-disabled-label-color: #D8D8D8;
  --var-primary-button-background-color: #2683B4;
  --var-primary-button-border-color: #2683B4;
  --var-primary-button-label-color: #FFFFFF;
  --var-primary-button-focus-background-color: #1C6890;
  --var-primary-button-focus-border-color: #FFFFFF;
  --var-primary-button-focus-label-color: #FFFFFF;
  --var-primary-button-hover-state-background-color: #2B658C;
  --var-primary-button-disabled-state-background-color: #F3F3F3;
  --var-primary-button-disabled-state-border-color: #E9E9E9;
  --var-primary-button-disabled-state-label-color: #D8D8D8;
  --var-secondary-button-label-color: #3984B7;
  --var-secondary-button-border-color: #3984B7;
  --var-secondary-button-background-color: #FFFFFF;
  --var-secondary-button-focus-label-color: #FFFFFF;
  --var-secondary-button-focus-border-color: #FFFFFF;
  --var-secondary-button-focus-background-color: #3984B7;
  --var-secondary-button-hover-state-background-color: #3984b8;
  --var-secondary-button-hover-label-color: #FFFFFF;
  --var-secondary-button-disabled-state-background-color: #FFFFFF;
  --var-secondary-button-disabled-state-border-color: #B5B5B5;
  --var-secondary-button-disabled-state-label-color: #D8D8D8;
  --var-tertiary-button-background-color: transparent;
  --var-tertiary-button-border-color: transparent;
  --var-tertiary-button-label-color: #3984b8;
  --var-tertiary-button-focus-background-color: transparent;
  --var-tertiary-button-focus-border-color: #8CC0FD;
  --var-tertiary-button-focus-label-color: #2D4254;
  --var-tertiary-button-hover-state-background-color: transparent;
  --var-tertiary-button-hover-label-color: #2D4254;
  --var-tertiary-button-disabled-state-background-color: transparent;
  --var-tertiary-button-disabled-state-border-color: transparent;
  --var-tertiary-button-disabled-state-label-color: #D8D8D8;
  --var-tertiary-button-visited-label-color: #4B9FAD;
  --var-cancel-button-background-color: #C31120;
  --var-cancel-button-border-color: #C31120;
  --var-cancel-button-label-color: #FFFFFF;
  --var-cancel-button-focus-background-color: #C31120;
  --var-cancel-button-focus-border-color: #FFFFFF;
  --var-cancel-button-focus-label-color: #FFFFFF;
  --var-cancel-button-disabled-state-background-color: #F3F3F3;
  --var-cancel-button-disabled-state-border-color: #F3F3F3;
  --var-cancel-button-disabled-state-label-color: #D8D8D8;
  --var-cancel-button-hover-state-background-color: #711119;
  --var-action-button-background-color: #1376AA;
  --var-action-button-border-color: #1376AA;
  --var-action-button-label-color: #FFFFFF;
  --var-action-button-focus-background-color: #1C6890;
  --var-action-button-focus-border-color: #FFFFFF;
  --var-action-button-focus-label-color: #FFFFFF;
  --var-action-button-hover-state-background-color: #2B658C;
  --var-action-button-disabled-state-background-color: #F3F3F3;
  --var-action-button-disabled-state-border-color: #E9E9E9;
  --var-action-button-disabled-state-label-color: #D8D8D8;
  --var-action-button-success-background-color: #2F8132;
  --var-action-button-failed-background-color: #B71C1C;
}
:root {
  --var-color-header-bottom-border: #DCDEE2;
}
:root {
  --var-color-icon-enabled: #2C96CE;
  --var-color-icon-disabled: #B5B5B5;
}
:root {
  --var-color-hamburger_menu-bkgr: #FFFFFF;
  --var-color-hamburger-patty: #000000;
  --var-color-hamburger-active: #FFFFFF;
  --var-color-wide-menu-header-bkgr: #146097;
  --var-color-wide-menu-bkgr: #FFFFFF;
  --var-color-wide-menu-active: #004B87;
  --var-color-wide-sub-menu-hdr-bkgr: #F3F3F3;
  --var-color-wide-sub-menu-hdr-text: #000000;
  --var-color-wide-sub-menu-link-bkgr: #FFFFFF;
  --var-color-wide-sub-menu-link-text: #000000;
  --var-color-wide-sub-menu-link-hover: #4189BA;
  --var-color-wide-sub-menu-link-hover-bkgr: #AEAEAE;
  --var-color-wide-sub-menu-link-disabled: #B5B5B5;
}
:root {
  --var-color-active-accordion-bkgr: #2683B4;
  --var-color-dflt-accordion-bkgr: #ffb300;
  --var-color-anchor-accordion: #353739;
  --var-color-brdr-accordion-clr: #B5B5B5;
}
:root {
  --var-color-active-paginator-bkgr: #3984B7;
}
:root {
  --var-color-alert-icon-success: #4caf50;
  --var-color-alert-bkgr-success: #cee7cf;
  --var-color-alert-icon-error: #b71c1c;
  --var-color-alert-bkgr-error: #fac7c8;
  --var-color-alert-icon-warn: #fbc02d;
  --var-color-alert-bkgr-warn: #f9f1c8;
  --var-color-alert-icon-info: #2d96cd;
  --var-color-alert-bkgr-info: #c6e1ee;
}
:root {
  --var-color-footer-text: #ffffff;
  --var-color-footer-bkgr: #353739;
}
:root {
  --var-color-surface: #f3f3f3;
  --var-color-shadow: rgba(0, 0, 0, 0.3);
}
:root {
  --var-color-tooltip-text: #ffffff;
  --var-color-tooltip-bkgr: #56585a;
  --var-color-tooltip-icon: #2D96CD;
}
:root {
  --var-color-field-header-text: #757575;
  --var-color-field-data-text: #242D31;
}
@font-face {
  font-family: "FordAntennaRERegular";
  src: url(/assets/fonts/Ford-Antenna-RE-Regular/ba3208b0-c2c3-48d2-96c8-71a9cdbe873b-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-RE-Regular/ba3208b0-c2c3-48d2-96c8-71a9cdbe873b-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-RE-Regular/ba3208b0-c2c3-48d2-96c8-71a9cdbe873b-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-RE-Regular/ba3208b0-c2c3-48d2-96c8-71a9cdbe873b-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-RE-Regular/ba3208b0-c2c3-48d2-96c8-71a9cdbe873b-1.ttf) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaBlackItalic";
  src: url(/assets/fonts/Ford-Antenna-Black-Italic/5935e7d0-2081-49bf-9b3b-026ea511bbeb-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Black-Italic/5935e7d0-2081-49bf-9b3b-026ea511bbeb-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Black-Italic/5935e7d0-2081-49bf-9b3b-026ea511bbeb-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Black-Italic/5935e7d0-2081-49bf-9b3b-026ea511bbeb-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Black-Italic/5935e7d0-2081-49bf-9b3b-026ea511bbeb-1.ttf) format("truetype");
  font-style: italic;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaBold";
  src: url(/assets/fonts/Ford-Antenna-Bold/1f6002e2-42c0-4332-8629-1dad7eb882ca-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Bold/1f6002e2-42c0-4332-8629-1dad7eb882ca-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Bold/1f6002e2-42c0-4332-8629-1dad7eb882ca-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Bold/1f6002e2-42c0-4332-8629-1dad7eb882ca-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Bold/1f6002e2-42c0-4332-8629-1dad7eb882ca-1.ttf) format("truetype");
  font-style: normal;
  font-weight: bold;
}
@font-face {
  font-family: "FordAntennaBoldItalic";
  src: url(/assets/fonts/Ford-Antenna-Bold-Italic/fb224575-dc8a-414f-8f22-034559e3bdba-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Bold-Italic/fb224575-dc8a-414f-8f22-034559e3bdba-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Bold-Italic/fb224575-dc8a-414f-8f22-034559e3bdba-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Bold-Italic/fb224575-dc8a-414f-8f22-034559e3bdba-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Bold-Italic/fb224575-dc8a-414f-8f22-034559e3bdba-1.ttf) format("truetype");
  font-style: italic;
  font-weight: bold;
}
@font-face {
  font-family: "FordAntennaExtraLight";
  src: url(/assets/fonts/Ford-Antenna-Extra-Light/240c900d-05a2-466d-9e76-f4d4f5c45b64-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Extra-Light/240c900d-05a2-466d-9e76-f4d4f5c45b64-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Extra-Light/240c900d-05a2-466d-9e76-f4d4f5c45b64-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Extra-Light/240c900d-05a2-466d-9e76-f4d4f5c45b64-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Extra-Light/240c900d-05a2-466d-9e76-f4d4f5c45b64-1.ttf) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaExtraLightItalic";
  src: url(/assets/fonts/Ford-Antenna-Extra-Light-Italic/4995d25d-28c9-4552-93aa-ce8da7c6844c-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Extra-Light-Italic/4995d25d-28c9-4552-93aa-ce8da7c6844c-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Extra-Light-Italic/4995d25d-28c9-4552-93aa-ce8da7c6844c-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Extra-Light-Italic/4995d25d-28c9-4552-93aa-ce8da7c6844c-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Extra-Light-Italic/4995d25d-28c9-4552-93aa-ce8da7c6844c-1.ttf) format("truetype");
  font-style: italic;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaLight";
  src: url(/assets/fonts/Ford-Antenna-Light/11f33cf4-3e86-4d2b-b2df-9e2ae91ba4b5-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Light/11f33cf4-3e86-4d2b-b2df-9e2ae91ba4b5-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Light/11f33cf4-3e86-4d2b-b2df-9e2ae91ba4b5-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Light/11f33cf4-3e86-4d2b-b2df-9e2ae91ba4b5-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Light/11f33cf4-3e86-4d2b-b2df-9e2ae91ba4b5-1.ttf) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaLightItalic";
  src: url(/assets/fonts/Ford-Antenna-Light-Italic/2f230fc8-026f-4a1a-82f5-2f116e1e5853-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Light-Italic/2f230fc8-026f-4a1a-82f5-2f116e1e5853-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Light-Italic/2f230fc8-026f-4a1a-82f5-2f116e1e5853-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Light-Italic/2f230fc8-026f-4a1a-82f5-2f116e1e5853-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Light-Italic/2f230fc8-026f-4a1a-82f5-2f116e1e5853-1.ttf) format("truetype");
  font-style: italic;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaMedium";
  src: url(/assets/fonts/Ford-Antenna-Medium/2b3c6cec-b81d-4903-89a0-aa111b549094-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Medium/2b3c6cec-b81d-4903-89a0-aa111b549094-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Medium/2b3c6cec-b81d-4903-89a0-aa111b549094-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Medium/2b3c6cec-b81d-4903-89a0-aa111b549094-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Medium/2b3c6cec-b81d-4903-89a0-aa111b549094-1.ttf) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaMediumItalic";
  src: url(/assets/fonts/Ford-Antenna-Medium-Italic/d99293c2-dd3d-405b-ad9a-38b0ea190902-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Medium-Italic/d99293c2-dd3d-405b-ad9a-38b0ea190902-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Medium-Italic/d99293c2-dd3d-405b-ad9a-38b0ea190902-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Medium-Italic/d99293c2-dd3d-405b-ad9a-38b0ea190902-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Medium-Italic/d99293c2-dd3d-405b-ad9a-38b0ea190902-1.ttf) format("truetype");
  font-style: italic;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaREBold";
  src: url(/assets/fonts/Ford-Antenna-RE-Bold/fc0da496-b015-4dea-b636-c32f57d8f930-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-RE-Bold/fc0da496-b015-4dea-b636-c32f57d8f930-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-RE-Bold/fc0da496-b015-4dea-b636-c32f57d8f930-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-RE-Bold/fc0da496-b015-4dea-b636-c32f57d8f930-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-RE-Bold/fc0da496-b015-4dea-b636-c32f57d8f930-1.ttf) format("truetype");
  font-style: normal;
  font-weight: bold;
}
@font-face {
  font-family: "FordAntennaREBoldItalic";
  src: url(/assets/fonts/Ford-Antenna-RE-Bold-Italic/e34546b0-0a01-4491-865a-bed1f37ff7e2-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-RE-Bold-Italic/e34546b0-0a01-4491-865a-bed1f37ff7e2-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-RE-Bold-Italic/e34546b0-0a01-4491-865a-bed1f37ff7e2-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-RE-Bold-Italic/e34546b0-0a01-4491-865a-bed1f37ff7e2-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-RE-Bold-Italic/e34546b0-0a01-4491-865a-bed1f37ff7e2-1.ttf) format("truetype");
  font-style: normal;
  font-weight: bold;
}
@font-face {
  font-family: "FordAntennaREItalic";
  src: url(/assets/fonts/Ford-Antenna-RE-Italic/e6d5d257-cbac-4b23-8465-c961efa5f1b1-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-RE-Italic/e6d5d257-cbac-4b23-8465-c961efa5f1b1-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-RE-Italic/e6d5d257-cbac-4b23-8465-c961efa5f1b1-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-RE-Italic/e6d5d257-cbac-4b23-8465-c961efa5f1b1-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-RE-Italic/e6d5d257-cbac-4b23-8465-c961efa5f1b1-1.ttf) format("truetype");
  font-style: italic;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaRegular";
  src: url(/assets/fonts/Ford-Antenna-Regular/a3a5e8f2-b656-4837-8a16-f448f0edd2b8-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Regular/a3a5e8f2-b656-4837-8a16-f448f0edd2b8-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Regular/a3a5e8f2-b656-4837-8a16-f448f0edd2b8-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Regular/a3a5e8f2-b656-4837-8a16-f448f0edd2b8-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Regular/a3a5e8f2-b656-4837-8a16-f448f0edd2b8-1.ttf) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaRegularItalic";
  src: url(/assets/fonts/Ford-Antenna-Regular-Italic/d3619808-0ee3-4f20-84c5-1cca83dfec44-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Regular-Italic/d3619808-0ee3-4f20-84c5-1cca83dfec44-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Regular-Italic/d3619808-0ee3-4f20-84c5-1cca83dfec44-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Regular-Italic/d3619808-0ee3-4f20-84c5-1cca83dfec44-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Regular-Italic/d3619808-0ee3-4f20-84c5-1cca83dfec44-1.ttf) format("truetype");
  font-style: italic;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaSemibold";
  src: url(/assets/fonts/Ford-Antenna-Semibold/10dd80e3-4884-48ff-9bad-d4613a4a88f6-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Semibold/10dd80e3-4884-48ff-9bad-d4613a4a88f6-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Semibold/10dd80e3-4884-48ff-9bad-d4613a4a88f6-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Semibold/10dd80e3-4884-48ff-9bad-d4613a4a88f6-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Semibold/10dd80e3-4884-48ff-9bad-d4613a4a88f6-1.ttf) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaSemiboldItalic";
  src: url(/assets/fonts/Ford-Antenna-Semibold-Italic/74967c8e-35d6-4581-b51f-119723668a0f-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Semibold-Italic/74967c8e-35d6-4581-b51f-119723668a0f-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Semibold-Italic/74967c8e-35d6-4581-b51f-119723668a0f-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Semibold-Italic/74967c8e-35d6-4581-b51f-119723668a0f-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Semibold-Italic/74967c8e-35d6-4581-b51f-119723668a0f-1.ttf) format("truetype");
  font-style: italic;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaThin";
  src: url(/assets/fonts/Ford-Antenna-Thin/82b82bb1-61ad-4573-84dc-b6c7316b1bda-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Thin/82b82bb1-61ad-4573-84dc-b6c7316b1bda-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Thin/82b82bb1-61ad-4573-84dc-b6c7316b1bda-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Thin/82b82bb1-61ad-4573-84dc-b6c7316b1bda-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Thin/82b82bb1-61ad-4573-84dc-b6c7316b1bda-1.ttf) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaThinItalic";
  src: url(/assets/fonts/Ford-Antenna-Thin-Italic/a75ec778-47e0-45ee-b9f5-4ac9dd808768-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Thin-Italic/a75ec778-47e0-45ee-b9f5-4ac9dd808768-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Thin-Italic/a75ec778-47e0-45ee-b9f5-4ac9dd808768-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Thin-Italic/a75ec778-47e0-45ee-b9f5-4ac9dd808768-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Thin-Italic/a75ec778-47e0-45ee-b9f5-4ac9dd808768-1.ttf) format("truetype");
  font-style: italic;
  font-weight: normal;
}
.ford-antenna-bold-3 {
  font-family: FordAntennaRegular, serif;
  font-weight: bold;
  font-size: 35px;
  line-height: normal;
  letter-spacing: 0.52px;
  color: var(--var-color-black);
  text-align: left;
}
.ota-spacer-top-25 {
  margin-top: 25px;
}
.ota-spacer-bottom-25 {
  margin-bottom: 25px;
}
.ota-spacer-top-30 {
  margin-top: 30px;
}
.ota-spacer-bottom-30 {
  margin-bottom: 30px;
}
.ota-spacer-top-35 {
  margin-top: 35px;
}
.ota-spacer-bottom-35 {
  margin-bottom: 35px;
}
h1 {
  font-family: FordAntennaRegular, serif;
  font-size: 30px;
  line-height: 36px;
  letter-spacing: 0.46px;
  color: var(--var-color-black);
}
h2 {
  font-family: FordAntennaMedium, serif;
  font-size: 25px;
  line-height: 30px;
  letter-spacing: 0.38px;
  color: var(--var-color-black);
  margin: 0;
}
h3 {
  font-family: FordAntennaRegular, serif;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.31px;
  color: var(--var-color-black);
}
h4 {
  font-family: FordAntennaRegular, serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.28px;
  color: var(--var-color-black);
}
h5 {
  font-family: FordAntennaBold, serif;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.22px;
  color: var(--var-color-black);
}
.ford-antenna-bold-1 {
  font-family: FordAntennaRegular, serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.2px;
  color: var(--var-color-black);
  text-align: left;
}
.font-disclaimer {
  font-family: FordAntennaMedium, serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.18px;
  color: var(--var-color-black);
}
.font-disclaimer-right-align {
  font-family: FordAntennaMedium, serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.18px;
  color: var(--var-color-black);
  text-align: right;
}
.font-disclaimer-center-align {
  font-family: FordAntennaMedium, serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.18px;
  color: var(--var-color-black);
  text-align: center;
}
.font-disclaimer-left-align {
  font-family: FordAntennaMedium, serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.18px;
  color: var(--var-color-black);
  text-align: left;
}
.ford-antenna-medium {
  font-family: FordAntennaRegular, serif;
  font-weight: bold;
  font-size: 35px;
  line-height: normal;
  letter-spacing: 0.52px;
  color: var(--var-color-black);
  text-align: left;
}
.font-breadcrumbs {
  font-family: FordAntennaRegular, serif;
  font-style: normal;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.18px;
  color: var(--var-color-dark-grey);
}
.font-breadcrumbs-right-align {
  font-family: FordAntennaRegular, serif;
  font-style: normal;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.18px;
  color: var(--var-color-dark-grey);
  text-align: right;
}
.font-breadcrumbs-center-align {
  font-family: FordAntennaRegular, serif;
  font-style: normal;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.18px;
  color: var(--var-color-dark-grey);
  text-align: center;
}
.font-breadcrumbs-left-align {
  font-family: FordAntennaRegular, serif;
  font-style: normal;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.18px;
  color: var(--var-color-dark-grey);
  text-align: left;
}
.body {
  font-family: FordAntennaRegular, serif;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 0.25px;
}
.review-header {
  font-family: FordAntennaMedium, serif;
  font-size: 13px;
  line-height: 15px;
  letter-spacing: 0.2px;
}
:root {
  --var-color-dark-blue: #1b394e;
  --var-color-blue: #004b87;
  --var-color-black: #353739;
  --var-color-dark-grey: #757575;
  --var-color-medium-grey: #b5b5b5;
  --var-color-mid-grey: #d8d8d8;
  --var-color-light-grey: #f3f3f3;
  --var-color-white: #ffffff;
}
:root {
  --var-color-blue-100: #2d96cd;
  --var-color-green-100: #4caf50;
  --var-color-yellow-100: #fdd835;
  --var-color-red-100: #b71c1c;
}
:root {
  --var-color-blue-150: #1c6890;
  --var-color-blue-125: #1376aa;
  --var-color-blue-75: #61b0d9;
  --var-color-blue-50: #93c7e3;
  --var-color-blue-25: #c6e1ee;
  --var-color-red-75: #c85454;
  --var-color-red-50: #d88a8a;
  --var-color-red-25: #ffebee;
  --var-color-yellow-125: #fbc02d;
  --var-color-yellow-75: #fde167;
  --var-color-yellow-50: #fbe897;
  --var-color-yellow-25: #f9f1c8;
  --var-color-green-150: #2f8132;
  --var-color-green-125: #419a45;
  --var-color-green-75: #78c27b;
  --var-color-green-50: #a2d4a4;
  --var-color-green-25: #cee7cf;
}
:root {
  --var-color-radio-button-dot: #3984B7;
  --var-disabled-label-color: #D8D8D8;
  --var-primary-button-background-color: #2683B4;
  --var-primary-button-border-color: #2683B4;
  --var-primary-button-label-color: #FFFFFF;
  --var-primary-button-focus-background-color: #1C6890;
  --var-primary-button-focus-border-color: #FFFFFF;
  --var-primary-button-focus-label-color: #FFFFFF;
  --var-primary-button-hover-state-background-color: #2B658C;
  --var-primary-button-disabled-state-background-color: #F3F3F3;
  --var-primary-button-disabled-state-border-color: #E9E9E9;
  --var-primary-button-disabled-state-label-color: #D8D8D8;
  --var-secondary-button-label-color: #3984B7;
  --var-secondary-button-border-color: #3984B7;
  --var-secondary-button-background-color: #FFFFFF;
  --var-secondary-button-focus-label-color: #FFFFFF;
  --var-secondary-button-focus-border-color: #FFFFFF;
  --var-secondary-button-focus-background-color: #3984B7;
  --var-secondary-button-hover-state-background-color: #3984b8;
  --var-secondary-button-hover-label-color: #FFFFFF;
  --var-secondary-button-disabled-state-background-color: #FFFFFF;
  --var-secondary-button-disabled-state-border-color: #B5B5B5;
  --var-secondary-button-disabled-state-label-color: #D8D8D8;
  --var-tertiary-button-background-color: transparent;
  --var-tertiary-button-border-color: transparent;
  --var-tertiary-button-label-color: #3984b8;
  --var-tertiary-button-focus-background-color: transparent;
  --var-tertiary-button-focus-border-color: #8CC0FD;
  --var-tertiary-button-focus-label-color: #2D4254;
  --var-tertiary-button-hover-state-background-color: transparent;
  --var-tertiary-button-hover-label-color: #2D4254;
  --var-tertiary-button-disabled-state-background-color: transparent;
  --var-tertiary-button-disabled-state-border-color: transparent;
  --var-tertiary-button-disabled-state-label-color: #D8D8D8;
  --var-tertiary-button-visited-label-color: #4B9FAD;
  --var-cancel-button-background-color: #C31120;
  --var-cancel-button-border-color: #C31120;
  --var-cancel-button-label-color: #FFFFFF;
  --var-cancel-button-focus-background-color: #C31120;
  --var-cancel-button-focus-border-color: #FFFFFF;
  --var-cancel-button-focus-label-color: #FFFFFF;
  --var-cancel-button-disabled-state-background-color: #F3F3F3;
  --var-cancel-button-disabled-state-border-color: #F3F3F3;
  --var-cancel-button-disabled-state-label-color: #D8D8D8;
  --var-cancel-button-hover-state-background-color: #711119;
  --var-action-button-background-color: #1376AA;
  --var-action-button-border-color: #1376AA;
  --var-action-button-label-color: #FFFFFF;
  --var-action-button-focus-background-color: #1C6890;
  --var-action-button-focus-border-color: #FFFFFF;
  --var-action-button-focus-label-color: #FFFFFF;
  --var-action-button-hover-state-background-color: #2B658C;
  --var-action-button-disabled-state-background-color: #F3F3F3;
  --var-action-button-disabled-state-border-color: #E9E9E9;
  --var-action-button-disabled-state-label-color: #D8D8D8;
  --var-action-button-success-background-color: #2F8132;
  --var-action-button-failed-background-color: #B71C1C;
}
:root {
  --var-color-header-bottom-border: #DCDEE2;
}
:root {
  --var-color-icon-enabled: #2C96CE;
  --var-color-icon-disabled: #B5B5B5;
}
:root {
  --var-color-hamburger_menu-bkgr: #FFFFFF;
  --var-color-hamburger-patty: #000000;
  --var-color-hamburger-active: #FFFFFF;
  --var-color-wide-menu-header-bkgr: #146097;
  --var-color-wide-menu-bkgr: #FFFFFF;
  --var-color-wide-menu-active: #004B87;
  --var-color-wide-sub-menu-hdr-bkgr: #F3F3F3;
  --var-color-wide-sub-menu-hdr-text: #000000;
  --var-color-wide-sub-menu-link-bkgr: #FFFFFF;
  --var-color-wide-sub-menu-link-text: #000000;
  --var-color-wide-sub-menu-link-hover: #4189BA;
  --var-color-wide-sub-menu-link-hover-bkgr: #AEAEAE;
  --var-color-wide-sub-menu-link-disabled: #B5B5B5;
}
:root {
  --var-color-active-accordion-bkgr: #2683B4;
  --var-color-dflt-accordion-bkgr: #ffb300;
  --var-color-anchor-accordion: #353739;
  --var-color-brdr-accordion-clr: #B5B5B5;
}
:root {
  --var-color-active-paginator-bkgr: #3984B7;
}
:root {
  --var-color-alert-icon-success: #4caf50;
  --var-color-alert-bkgr-success: #cee7cf;
  --var-color-alert-icon-error: #b71c1c;
  --var-color-alert-bkgr-error: #fac7c8;
  --var-color-alert-icon-warn: #fbc02d;
  --var-color-alert-bkgr-warn: #f9f1c8;
  --var-color-alert-icon-info: #2d96cd;
  --var-color-alert-bkgr-info: #c6e1ee;
}
:root {
  --var-color-footer-text: #ffffff;
  --var-color-footer-bkgr: #353739;
}
:root {
  --var-color-surface: #f3f3f3;
  --var-color-shadow: rgba(0, 0, 0, 0.3);
}
:root {
  --var-color-tooltip-text: #ffffff;
  --var-color-tooltip-bkgr: #56585a;
  --var-color-tooltip-icon: #2D96CD;
}
:root {
  --var-color-field-header-text: #757575;
  --var-color-field-data-text: #242D31;
}
:root {
  --var-color-dark-blue: #1b394e;
  --var-color-blue: #004b87;
  --var-color-black: #353739;
  --var-color-dark-grey: #757575;
  --var-color-medium-grey: #b5b5b5;
  --var-color-mid-grey: #d8d8d8;
  --var-color-light-grey: #f3f3f3;
  --var-color-white: #ffffff;
}
:root {
  --var-color-active-accordion-bkgr: #2683B4;
  --var-color-dflt-accordion-bkgr: #ffb300;
  --var-color-anchor-accordion: #353739;
  --var-color-brdr-accordion-clr: #B5B5B5;
}
:host::ng-deep .ota-accordion .p-accordion .p-accordion-header {
  font-family: FordAntennaBold;
  font-size: 14pt !important;
}
:host::ng-deep .ota-accordion .p-accordion .p-accordion-header:not(.p-disabled).p-menuitem-state-active {
  background-color: var(--var-color-active-accordion-bkgr);
  border-color: var(--var-color-active-accordion-bkgr);
}
:host::ng-deep .ota-accordion .p-accordion .p-accordion-header .p-menuitem-state-default .p-menuitem-state-active {
  background-color: var(--var-color-dflt-accordion-bkgr);
}
:host::ng-deep .ota-accordion .p-accordion .p-accordion-header > a {
  color: var(--var-color-anchor-accordion);
}
:host::ng-deep .ota-accordion .p-accordion .p-accordion-header .p-menuitem-state-default {
  border-color: var(--var-color-brdr-accordion-clr) !important;
}
:host::ng-deep .ota-accordion .p-accordion .p-accordion-content {
  padding: 35px !important;
  border-color: var(--var-color-brdr-accordion-clr);
}
:host::ng-deep .ota-accordion .p-accordion .p-accordion-content .p-menuitem-link .p-menuitem-text {
  color: var(--var-color-black);
  font-size: 10px;
  font-weight: bolder;
}
:host::ng-deep .ota-card .p-card .p-card-header .card-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: keep-all;
}
:host::ng-deep .ota-card .p-card .p-card-body {
  word-break: break-word;
  white-space: normal;
  overflow-y: auto;
  height: 100%;
}
:host::ng-deep .p-button {
  width: auto;
  font-weight: bold;
  border-radius: 2px;
  border: 2px solid;
  padding: 0 1em 0 1em;
  font-size: 15px;
  min-width: 112px;
}
:root {
  --var-color-dark-blue: #1b394e;
  --var-color-blue: #004b87;
  --var-color-black: #353739;
  --var-color-dark-grey: #757575;
  --var-color-medium-grey: #b5b5b5;
  --var-color-mid-grey: #d8d8d8;
  --var-color-light-grey: #f3f3f3;
  --var-color-white: #ffffff;
}
:root {
  --var-color-blue-100: #2d96cd;
  --var-color-green-100: #4caf50;
  --var-color-yellow-100: #fdd835;
  --var-color-red-100: #b71c1c;
}
:root {
  --var-color-blue-150: #1c6890;
  --var-color-blue-125: #1376aa;
  --var-color-blue-75: #61b0d9;
  --var-color-blue-50: #93c7e3;
  --var-color-blue-25: #c6e1ee;
  --var-color-red-75: #c85454;
  --var-color-red-50: #d88a8a;
  --var-color-red-25: #ffebee;
  --var-color-yellow-125: #fbc02d;
  --var-color-yellow-75: #fde167;
  --var-color-yellow-50: #fbe897;
  --var-color-yellow-25: #f9f1c8;
  --var-color-green-150: #2f8132;
  --var-color-green-125: #419a45;
  --var-color-green-75: #78c27b;
  --var-color-green-50: #a2d4a4;
  --var-color-green-25: #cee7cf;
}
:root {
  --var-color-radio-button-dot: #3984B7;
  --var-disabled-label-color: #D8D8D8;
  --var-primary-button-background-color: #2683B4;
  --var-primary-button-border-color: #2683B4;
  --var-primary-button-label-color: #FFFFFF;
  --var-primary-button-focus-background-color: #1C6890;
  --var-primary-button-focus-border-color: #FFFFFF;
  --var-primary-button-focus-label-color: #FFFFFF;
  --var-primary-button-hover-state-background-color: #2B658C;
  --var-primary-button-disabled-state-background-color: #F3F3F3;
  --var-primary-button-disabled-state-border-color: #E9E9E9;
  --var-primary-button-disabled-state-label-color: #D8D8D8;
  --var-secondary-button-label-color: #3984B7;
  --var-secondary-button-border-color: #3984B7;
  --var-secondary-button-background-color: #FFFFFF;
  --var-secondary-button-focus-label-color: #FFFFFF;
  --var-secondary-button-focus-border-color: #FFFFFF;
  --var-secondary-button-focus-background-color: #3984B7;
  --var-secondary-button-hover-state-background-color: #3984b8;
  --var-secondary-button-hover-label-color: #FFFFFF;
  --var-secondary-button-disabled-state-background-color: #FFFFFF;
  --var-secondary-button-disabled-state-border-color: #B5B5B5;
  --var-secondary-button-disabled-state-label-color: #D8D8D8;
  --var-tertiary-button-background-color: transparent;
  --var-tertiary-button-border-color: transparent;
  --var-tertiary-button-label-color: #3984b8;
  --var-tertiary-button-focus-background-color: transparent;
  --var-tertiary-button-focus-border-color: #8CC0FD;
  --var-tertiary-button-focus-label-color: #2D4254;
  --var-tertiary-button-hover-state-background-color: transparent;
  --var-tertiary-button-hover-label-color: #2D4254;
  --var-tertiary-button-disabled-state-background-color: transparent;
  --var-tertiary-button-disabled-state-border-color: transparent;
  --var-tertiary-button-disabled-state-label-color: #D8D8D8;
  --var-tertiary-button-visited-label-color: #4B9FAD;
  --var-cancel-button-background-color: #C31120;
  --var-cancel-button-border-color: #C31120;
  --var-cancel-button-label-color: #FFFFFF;
  --var-cancel-button-focus-background-color: #C31120;
  --var-cancel-button-focus-border-color: #FFFFFF;
  --var-cancel-button-focus-label-color: #FFFFFF;
  --var-cancel-button-disabled-state-background-color: #F3F3F3;
  --var-cancel-button-disabled-state-border-color: #F3F3F3;
  --var-cancel-button-disabled-state-label-color: #D8D8D8;
  --var-cancel-button-hover-state-background-color: #711119;
  --var-action-button-background-color: #1376AA;
  --var-action-button-border-color: #1376AA;
  --var-action-button-label-color: #FFFFFF;
  --var-action-button-focus-background-color: #1C6890;
  --var-action-button-focus-border-color: #FFFFFF;
  --var-action-button-focus-label-color: #FFFFFF;
  --var-action-button-hover-state-background-color: #2B658C;
  --var-action-button-disabled-state-background-color: #F3F3F3;
  --var-action-button-disabled-state-border-color: #E9E9E9;
  --var-action-button-disabled-state-label-color: #D8D8D8;
  --var-action-button-success-background-color: #2F8132;
  --var-action-button-failed-background-color: #B71C1C;
}
:root {
  --var-color-header-bottom-border: #DCDEE2;
}
:root {
  --var-color-icon-enabled: #2C96CE;
  --var-color-icon-disabled: #B5B5B5;
}
:root {
  --var-color-hamburger_menu-bkgr: #FFFFFF;
  --var-color-hamburger-patty: #000000;
  --var-color-hamburger-active: #FFFFFF;
  --var-color-wide-menu-header-bkgr: #146097;
  --var-color-wide-menu-bkgr: #FFFFFF;
  --var-color-wide-menu-active: #004B87;
  --var-color-wide-sub-menu-hdr-bkgr: #F3F3F3;
  --var-color-wide-sub-menu-hdr-text: #000000;
  --var-color-wide-sub-menu-link-bkgr: #FFFFFF;
  --var-color-wide-sub-menu-link-text: #000000;
  --var-color-wide-sub-menu-link-hover: #4189BA;
  --var-color-wide-sub-menu-link-hover-bkgr: #AEAEAE;
  --var-color-wide-sub-menu-link-disabled: #B5B5B5;
}
:root {
  --var-color-active-accordion-bkgr: #2683B4;
  --var-color-dflt-accordion-bkgr: #ffb300;
  --var-color-anchor-accordion: #353739;
  --var-color-brdr-accordion-clr: #B5B5B5;
}
:root {
  --var-color-active-paginator-bkgr: #3984B7;
}
:root {
  --var-color-alert-icon-success: #4caf50;
  --var-color-alert-bkgr-success: #cee7cf;
  --var-color-alert-icon-error: #b71c1c;
  --var-color-alert-bkgr-error: #fac7c8;
  --var-color-alert-icon-warn: #fbc02d;
  --var-color-alert-bkgr-warn: #f9f1c8;
  --var-color-alert-icon-info: #2d96cd;
  --var-color-alert-bkgr-info: #c6e1ee;
}
:root {
  --var-color-footer-text: #ffffff;
  --var-color-footer-bkgr: #353739;
}
:root {
  --var-color-surface: #f3f3f3;
  --var-color-shadow: rgba(0, 0, 0, 0.3);
}
:root {
  --var-color-tooltip-text: #ffffff;
  --var-color-tooltip-bkgr: #56585a;
  --var-color-tooltip-icon: #2D96CD;
}
:root {
  --var-color-field-header-text: #757575;
  --var-color-field-data-text: #242D31;
}
:root {
  --var-color-dark-blue: #1b394e;
  --var-color-blue: #004b87;
  --var-color-black: #353739;
  --var-color-dark-grey: #757575;
  --var-color-medium-grey: #b5b5b5;
  --var-color-mid-grey: #d8d8d8;
  --var-color-light-grey: #f3f3f3;
  --var-color-white: #ffffff;
}
:root {
  --var-color-blue-100: #2d96cd;
  --var-color-green-100: #4caf50;
  --var-color-yellow-100: #fdd835;
  --var-color-red-100: #b71c1c;
}
:root {
  --var-color-blue-150: #1c6890;
  --var-color-blue-125: #1376aa;
  --var-color-blue-75: #61b0d9;
  --var-color-blue-50: #93c7e3;
  --var-color-blue-25: #c6e1ee;
  --var-color-red-75: #c85454;
  --var-color-red-50: #d88a8a;
  --var-color-red-25: #ffebee;
  --var-color-yellow-125: #fbc02d;
  --var-color-yellow-75: #fde167;
  --var-color-yellow-50: #fbe897;
  --var-color-yellow-25: #f9f1c8;
  --var-color-green-150: #2f8132;
  --var-color-green-125: #419a45;
  --var-color-green-75: #78c27b;
  --var-color-green-50: #a2d4a4;
  --var-color-green-25: #cee7cf;
}
:root {
  --var-color-radio-button-dot: #3984B7;
  --var-disabled-label-color: #D8D8D8;
  --var-primary-button-background-color: #2683B4;
  --var-primary-button-border-color: #2683B4;
  --var-primary-button-label-color: #FFFFFF;
  --var-primary-button-focus-background-color: #1C6890;
  --var-primary-button-focus-border-color: #FFFFFF;
  --var-primary-button-focus-label-color: #FFFFFF;
  --var-primary-button-hover-state-background-color: #2B658C;
  --var-primary-button-disabled-state-background-color: #F3F3F3;
  --var-primary-button-disabled-state-border-color: #E9E9E9;
  --var-primary-button-disabled-state-label-color: #D8D8D8;
  --var-secondary-button-label-color: #3984B7;
  --var-secondary-button-border-color: #3984B7;
  --var-secondary-button-background-color: #FFFFFF;
  --var-secondary-button-focus-label-color: #FFFFFF;
  --var-secondary-button-focus-border-color: #FFFFFF;
  --var-secondary-button-focus-background-color: #3984B7;
  --var-secondary-button-hover-state-background-color: #3984b8;
  --var-secondary-button-hover-label-color: #FFFFFF;
  --var-secondary-button-disabled-state-background-color: #FFFFFF;
  --var-secondary-button-disabled-state-border-color: #B5B5B5;
  --var-secondary-button-disabled-state-label-color: #D8D8D8;
  --var-tertiary-button-background-color: transparent;
  --var-tertiary-button-border-color: transparent;
  --var-tertiary-button-label-color: #3984b8;
  --var-tertiary-button-focus-background-color: transparent;
  --var-tertiary-button-focus-border-color: #8CC0FD;
  --var-tertiary-button-focus-label-color: #2D4254;
  --var-tertiary-button-hover-state-background-color: transparent;
  --var-tertiary-button-hover-label-color: #2D4254;
  --var-tertiary-button-disabled-state-background-color: transparent;
  --var-tertiary-button-disabled-state-border-color: transparent;
  --var-tertiary-button-disabled-state-label-color: #D8D8D8;
  --var-tertiary-button-visited-label-color: #4B9FAD;
  --var-cancel-button-background-color: #C31120;
  --var-cancel-button-border-color: #C31120;
  --var-cancel-button-label-color: #FFFFFF;
  --var-cancel-button-focus-background-color: #C31120;
  --var-cancel-button-focus-border-color: #FFFFFF;
  --var-cancel-button-focus-label-color: #FFFFFF;
  --var-cancel-button-disabled-state-background-color: #F3F3F3;
  --var-cancel-button-disabled-state-border-color: #F3F3F3;
  --var-cancel-button-disabled-state-label-color: #D8D8D8;
  --var-cancel-button-hover-state-background-color: #711119;
  --var-action-button-background-color: #1376AA;
  --var-action-button-border-color: #1376AA;
  --var-action-button-label-color: #FFFFFF;
  --var-action-button-focus-background-color: #1C6890;
  --var-action-button-focus-border-color: #FFFFFF;
  --var-action-button-focus-label-color: #FFFFFF;
  --var-action-button-hover-state-background-color: #2B658C;
  --var-action-button-disabled-state-background-color: #F3F3F3;
  --var-action-button-disabled-state-border-color: #E9E9E9;
  --var-action-button-disabled-state-label-color: #D8D8D8;
  --var-action-button-success-background-color: #2F8132;
  --var-action-button-failed-background-color: #B71C1C;
}
:root {
  --var-color-header-bottom-border: #DCDEE2;
}
:root {
  --var-color-icon-enabled: #2C96CE;
  --var-color-icon-disabled: #B5B5B5;
}
:root {
  --var-color-hamburger_menu-bkgr: #FFFFFF;
  --var-color-hamburger-patty: #000000;
  --var-color-hamburger-active: #FFFFFF;
  --var-color-wide-menu-header-bkgr: #146097;
  --var-color-wide-menu-bkgr: #FFFFFF;
  --var-color-wide-menu-active: #004B87;
  --var-color-wide-sub-menu-hdr-bkgr: #F3F3F3;
  --var-color-wide-sub-menu-hdr-text: #000000;
  --var-color-wide-sub-menu-link-bkgr: #FFFFFF;
  --var-color-wide-sub-menu-link-text: #000000;
  --var-color-wide-sub-menu-link-hover: #4189BA;
  --var-color-wide-sub-menu-link-hover-bkgr: #AEAEAE;
  --var-color-wide-sub-menu-link-disabled: #B5B5B5;
}
:root {
  --var-color-active-accordion-bkgr: #2683B4;
  --var-color-dflt-accordion-bkgr: #ffb300;
  --var-color-anchor-accordion: #353739;
  --var-color-brdr-accordion-clr: #B5B5B5;
}
:root {
  --var-color-active-paginator-bkgr: #3984B7;
}
:root {
  --var-color-alert-icon-success: #4caf50;
  --var-color-alert-bkgr-success: #cee7cf;
  --var-color-alert-icon-error: #b71c1c;
  --var-color-alert-bkgr-error: #fac7c8;
  --var-color-alert-icon-warn: #fbc02d;
  --var-color-alert-bkgr-warn: #f9f1c8;
  --var-color-alert-icon-info: #2d96cd;
  --var-color-alert-bkgr-info: #c6e1ee;
}
:root {
  --var-color-footer-text: #ffffff;
  --var-color-footer-bkgr: #353739;
}
:root {
  --var-color-surface: #f3f3f3;
  --var-color-shadow: rgba(0, 0, 0, 0.3);
}
:root {
  --var-color-tooltip-text: #ffffff;
  --var-color-tooltip-bkgr: #56585a;
  --var-color-tooltip-icon: #2D96CD;
}
:root {
  --var-color-field-header-text: #757575;
  --var-color-field-data-text: #242D31;
}
@font-face {
  font-family: "FordAntennaRERegular";
  src: url(/assets/fonts/Ford-Antenna-RE-Regular/ba3208b0-c2c3-48d2-96c8-71a9cdbe873b-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-RE-Regular/ba3208b0-c2c3-48d2-96c8-71a9cdbe873b-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-RE-Regular/ba3208b0-c2c3-48d2-96c8-71a9cdbe873b-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-RE-Regular/ba3208b0-c2c3-48d2-96c8-71a9cdbe873b-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-RE-Regular/ba3208b0-c2c3-48d2-96c8-71a9cdbe873b-1.ttf) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaBlackItalic";
  src: url(/assets/fonts/Ford-Antenna-Black-Italic/5935e7d0-2081-49bf-9b3b-026ea511bbeb-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Black-Italic/5935e7d0-2081-49bf-9b3b-026ea511bbeb-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Black-Italic/5935e7d0-2081-49bf-9b3b-026ea511bbeb-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Black-Italic/5935e7d0-2081-49bf-9b3b-026ea511bbeb-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Black-Italic/5935e7d0-2081-49bf-9b3b-026ea511bbeb-1.ttf) format("truetype");
  font-style: italic;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaBold";
  src: url(/assets/fonts/Ford-Antenna-Bold/1f6002e2-42c0-4332-8629-1dad7eb882ca-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Bold/1f6002e2-42c0-4332-8629-1dad7eb882ca-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Bold/1f6002e2-42c0-4332-8629-1dad7eb882ca-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Bold/1f6002e2-42c0-4332-8629-1dad7eb882ca-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Bold/1f6002e2-42c0-4332-8629-1dad7eb882ca-1.ttf) format("truetype");
  font-style: normal;
  font-weight: bold;
}
@font-face {
  font-family: "FordAntennaBoldItalic";
  src: url(/assets/fonts/Ford-Antenna-Bold-Italic/fb224575-dc8a-414f-8f22-034559e3bdba-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Bold-Italic/fb224575-dc8a-414f-8f22-034559e3bdba-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Bold-Italic/fb224575-dc8a-414f-8f22-034559e3bdba-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Bold-Italic/fb224575-dc8a-414f-8f22-034559e3bdba-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Bold-Italic/fb224575-dc8a-414f-8f22-034559e3bdba-1.ttf) format("truetype");
  font-style: italic;
  font-weight: bold;
}
@font-face {
  font-family: "FordAntennaExtraLight";
  src: url(/assets/fonts/Ford-Antenna-Extra-Light/240c900d-05a2-466d-9e76-f4d4f5c45b64-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Extra-Light/240c900d-05a2-466d-9e76-f4d4f5c45b64-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Extra-Light/240c900d-05a2-466d-9e76-f4d4f5c45b64-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Extra-Light/240c900d-05a2-466d-9e76-f4d4f5c45b64-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Extra-Light/240c900d-05a2-466d-9e76-f4d4f5c45b64-1.ttf) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaExtraLightItalic";
  src: url(/assets/fonts/Ford-Antenna-Extra-Light-Italic/4995d25d-28c9-4552-93aa-ce8da7c6844c-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Extra-Light-Italic/4995d25d-28c9-4552-93aa-ce8da7c6844c-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Extra-Light-Italic/4995d25d-28c9-4552-93aa-ce8da7c6844c-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Extra-Light-Italic/4995d25d-28c9-4552-93aa-ce8da7c6844c-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Extra-Light-Italic/4995d25d-28c9-4552-93aa-ce8da7c6844c-1.ttf) format("truetype");
  font-style: italic;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaLight";
  src: url(/assets/fonts/Ford-Antenna-Light/11f33cf4-3e86-4d2b-b2df-9e2ae91ba4b5-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Light/11f33cf4-3e86-4d2b-b2df-9e2ae91ba4b5-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Light/11f33cf4-3e86-4d2b-b2df-9e2ae91ba4b5-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Light/11f33cf4-3e86-4d2b-b2df-9e2ae91ba4b5-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Light/11f33cf4-3e86-4d2b-b2df-9e2ae91ba4b5-1.ttf) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaLightItalic";
  src: url(/assets/fonts/Ford-Antenna-Light-Italic/2f230fc8-026f-4a1a-82f5-2f116e1e5853-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Light-Italic/2f230fc8-026f-4a1a-82f5-2f116e1e5853-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Light-Italic/2f230fc8-026f-4a1a-82f5-2f116e1e5853-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Light-Italic/2f230fc8-026f-4a1a-82f5-2f116e1e5853-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Light-Italic/2f230fc8-026f-4a1a-82f5-2f116e1e5853-1.ttf) format("truetype");
  font-style: italic;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaMedium";
  src: url(/assets/fonts/Ford-Antenna-Medium/2b3c6cec-b81d-4903-89a0-aa111b549094-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Medium/2b3c6cec-b81d-4903-89a0-aa111b549094-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Medium/2b3c6cec-b81d-4903-89a0-aa111b549094-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Medium/2b3c6cec-b81d-4903-89a0-aa111b549094-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Medium/2b3c6cec-b81d-4903-89a0-aa111b549094-1.ttf) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaMediumItalic";
  src: url(/assets/fonts/Ford-Antenna-Medium-Italic/d99293c2-dd3d-405b-ad9a-38b0ea190902-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Medium-Italic/d99293c2-dd3d-405b-ad9a-38b0ea190902-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Medium-Italic/d99293c2-dd3d-405b-ad9a-38b0ea190902-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Medium-Italic/d99293c2-dd3d-405b-ad9a-38b0ea190902-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Medium-Italic/d99293c2-dd3d-405b-ad9a-38b0ea190902-1.ttf) format("truetype");
  font-style: italic;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaREBold";
  src: url(/assets/fonts/Ford-Antenna-RE-Bold/fc0da496-b015-4dea-b636-c32f57d8f930-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-RE-Bold/fc0da496-b015-4dea-b636-c32f57d8f930-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-RE-Bold/fc0da496-b015-4dea-b636-c32f57d8f930-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-RE-Bold/fc0da496-b015-4dea-b636-c32f57d8f930-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-RE-Bold/fc0da496-b015-4dea-b636-c32f57d8f930-1.ttf) format("truetype");
  font-style: normal;
  font-weight: bold;
}
@font-face {
  font-family: "FordAntennaREBoldItalic";
  src: url(/assets/fonts/Ford-Antenna-RE-Bold-Italic/e34546b0-0a01-4491-865a-bed1f37ff7e2-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-RE-Bold-Italic/e34546b0-0a01-4491-865a-bed1f37ff7e2-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-RE-Bold-Italic/e34546b0-0a01-4491-865a-bed1f37ff7e2-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-RE-Bold-Italic/e34546b0-0a01-4491-865a-bed1f37ff7e2-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-RE-Bold-Italic/e34546b0-0a01-4491-865a-bed1f37ff7e2-1.ttf) format("truetype");
  font-style: normal;
  font-weight: bold;
}
@font-face {
  font-family: "FordAntennaREItalic";
  src: url(/assets/fonts/Ford-Antenna-RE-Italic/e6d5d257-cbac-4b23-8465-c961efa5f1b1-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-RE-Italic/e6d5d257-cbac-4b23-8465-c961efa5f1b1-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-RE-Italic/e6d5d257-cbac-4b23-8465-c961efa5f1b1-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-RE-Italic/e6d5d257-cbac-4b23-8465-c961efa5f1b1-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-RE-Italic/e6d5d257-cbac-4b23-8465-c961efa5f1b1-1.ttf) format("truetype");
  font-style: italic;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaRegular";
  src: url(/assets/fonts/Ford-Antenna-Regular/a3a5e8f2-b656-4837-8a16-f448f0edd2b8-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Regular/a3a5e8f2-b656-4837-8a16-f448f0edd2b8-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Regular/a3a5e8f2-b656-4837-8a16-f448f0edd2b8-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Regular/a3a5e8f2-b656-4837-8a16-f448f0edd2b8-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Regular/a3a5e8f2-b656-4837-8a16-f448f0edd2b8-1.ttf) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaRegularItalic";
  src: url(/assets/fonts/Ford-Antenna-Regular-Italic/d3619808-0ee3-4f20-84c5-1cca83dfec44-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Regular-Italic/d3619808-0ee3-4f20-84c5-1cca83dfec44-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Regular-Italic/d3619808-0ee3-4f20-84c5-1cca83dfec44-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Regular-Italic/d3619808-0ee3-4f20-84c5-1cca83dfec44-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Regular-Italic/d3619808-0ee3-4f20-84c5-1cca83dfec44-1.ttf) format("truetype");
  font-style: italic;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaSemibold";
  src: url(/assets/fonts/Ford-Antenna-Semibold/10dd80e3-4884-48ff-9bad-d4613a4a88f6-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Semibold/10dd80e3-4884-48ff-9bad-d4613a4a88f6-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Semibold/10dd80e3-4884-48ff-9bad-d4613a4a88f6-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Semibold/10dd80e3-4884-48ff-9bad-d4613a4a88f6-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Semibold/10dd80e3-4884-48ff-9bad-d4613a4a88f6-1.ttf) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaSemiboldItalic";
  src: url(/assets/fonts/Ford-Antenna-Semibold-Italic/74967c8e-35d6-4581-b51f-119723668a0f-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Semibold-Italic/74967c8e-35d6-4581-b51f-119723668a0f-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Semibold-Italic/74967c8e-35d6-4581-b51f-119723668a0f-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Semibold-Italic/74967c8e-35d6-4581-b51f-119723668a0f-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Semibold-Italic/74967c8e-35d6-4581-b51f-119723668a0f-1.ttf) format("truetype");
  font-style: italic;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaThin";
  src: url(/assets/fonts/Ford-Antenna-Thin/82b82bb1-61ad-4573-84dc-b6c7316b1bda-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Thin/82b82bb1-61ad-4573-84dc-b6c7316b1bda-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Thin/82b82bb1-61ad-4573-84dc-b6c7316b1bda-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Thin/82b82bb1-61ad-4573-84dc-b6c7316b1bda-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Thin/82b82bb1-61ad-4573-84dc-b6c7316b1bda-1.ttf) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "FordAntennaThinItalic";
  src: url(/assets/fonts/Ford-Antenna-Thin-Italic/a75ec778-47e0-45ee-b9f5-4ac9dd808768-2.eot);
  src:
    url(/assets/fonts/Ford-Antenna-Thin-Italic/a75ec778-47e0-45ee-b9f5-4ac9dd808768-2.eot) format("embedded-opentype"),
    url(/assets/fonts/Ford-Antenna-Thin-Italic/a75ec778-47e0-45ee-b9f5-4ac9dd808768-5.woff2) format("woff2"),
    url(/assets/fonts/Ford-Antenna-Thin-Italic/a75ec778-47e0-45ee-b9f5-4ac9dd808768-3.woff) format("woff"),
    url(/assets/fonts/Ford-Antenna-Thin-Italic/a75ec778-47e0-45ee-b9f5-4ac9dd808768-1.ttf) format("truetype");
  font-style: italic;
  font-weight: normal;
}
.ford-antenna-bold-3 {
  font-family: FordAntennaRegular, serif;
  font-weight: bold;
  font-size: 35px;
  line-height: normal;
  letter-spacing: 0.52px;
  color: var(--var-color-black);
  text-align: left;
}
.ota-spacer-top-25 {
  margin-top: 25px;
}
.ota-spacer-bottom-25 {
  margin-bottom: 25px;
}
.ota-spacer-top-30 {
  margin-top: 30px;
}
.ota-spacer-bottom-30 {
  margin-bottom: 30px;
}
.ota-spacer-top-35 {
  margin-top: 35px;
}
.ota-spacer-bottom-35 {
  margin-bottom: 35px;
}
h1 {
  font-family: FordAntennaRegular, serif;
  font-size: 30px;
  line-height: 36px;
  letter-spacing: 0.46px;
  color: var(--var-color-black);
}
h2 {
  font-family: FordAntennaMedium, serif;
  font-size: 25px;
  line-height: 30px;
  letter-spacing: 0.38px;
  color: var(--var-color-black);
  margin: 0;
}
h3 {
  font-family: FordAntennaRegular, serif;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.31px;
  color: var(--var-color-black);
}
h4 {
  font-family: FordAntennaRegular, serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.28px;
  color: var(--var-color-black);
}
h5 {
  font-family: FordAntennaBold, serif;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.22px;
  color: var(--var-color-black);
}
.ford-antenna-bold-1 {
  font-family: FordAntennaRegular, serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.2px;
  color: var(--var-color-black);
  text-align: left;
}
.font-disclaimer {
  font-family: FordAntennaMedium, serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.18px;
  color: var(--var-color-black);
}
.font-disclaimer-right-align {
  font-family: FordAntennaMedium, serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.18px;
  color: var(--var-color-black);
  text-align: right;
}
.font-disclaimer-center-align {
  font-family: FordAntennaMedium, serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.18px;
  color: var(--var-color-black);
  text-align: center;
}
.font-disclaimer-left-align {
  font-family: FordAntennaMedium, serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.18px;
  color: var(--var-color-black);
  text-align: left;
}
.ford-antenna-medium {
  font-family: FordAntennaRegular, serif;
  font-weight: bold;
  font-size: 35px;
  line-height: normal;
  letter-spacing: 0.52px;
  color: var(--var-color-black);
  text-align: left;
}
.font-breadcrumbs {
  font-family: FordAntennaRegular, serif;
  font-style: normal;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.18px;
  color: var(--var-color-dark-grey);
}
.font-breadcrumbs-right-align {
  font-family: FordAntennaRegular, serif;
  font-style: normal;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.18px;
  color: var(--var-color-dark-grey);
  text-align: right;
}
.font-breadcrumbs-center-align {
  font-family: FordAntennaRegular, serif;
  font-style: normal;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.18px;
  color: var(--var-color-dark-grey);
  text-align: center;
}
.font-breadcrumbs-left-align {
  font-family: FordAntennaRegular, serif;
  font-style: normal;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.18px;
  color: var(--var-color-dark-grey);
  text-align: left;
}
.body {
  font-family: FordAntennaRegular, serif;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 0.25px;
}
.review-header {
  font-family: FordAntennaMedium, serif;
  font-size: 13px;
  line-height: 15px;
  letter-spacing: 0.2px;
}
.ota-field-header {
  line-height: 25px;
  font-size: 16px;
  font-family: FordAntennaRegular;
  color: var(--var-color-field-header-text);
  margin-bottom: 10px;
  size: 13px;
  letter-spacing: 0.2px;
}
.ota-field-data {
  line-height: 18px;
  font-size: 15px;
  font-family: FordAntennaRegular;
  color: var(--var-color-field-data-text);
  margin-bottom: 25px;
  size: 15px;
  letter-spacing: 0.23px;
}
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
body .p-component,
body .p-terminal .p-terminal-input,
body .p-datatable .p-editable-column input,
body .p-treetable .p-editable-column input,
body .p-chips > ul.p-inputtext .p-chips-input-token input,
body .p-autocomplete.p-autocomplete-multiple .p-autocomplete-multiple-container .p-autocomplete-input-token input {
  font-family: FordAntennaRegular;
}
.ota-expandable-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: keep-all;
}
.ota-expandable-ellipsis:hover {
  overflow: visible;
  word-break: break-word;
  white-space: normal;
}
.ota-search-icon {
  width: 100%;
}
.ota-search-icon i {
  position: absolute;
}
.ota-search-icon .ota-icon {
  padding: 8px;
  min-width: 20px;
  text-align: center;
}
.ota-search-icon .ota-input-field {
  width: 100%;
  padding-left: 26px;
}
.ota-auto-expand {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: keep-all;
}
.ota-auto-expand:hover {
  overflow: visible;
  word-break: break-word;
  white-space: normal;
}
.ota-page-base .ota-page-header,
.ota-page-base .ota-page-footer {
  width: 100%;
  height: fit-content;
  min-height: 40px;
}
.ota-page-header {
  margin: 0;
  height: 74px;
  border-bottom: solid 1px var(--var-color-header-bottom-border);
}
.ota-content {
  margin: 0;
  background-color: var(--var-color-white);
  min-height: calc(100vh - 113px);
  height: fit-content;
  border: 30px solid var(--var-color-light-grey);
  padding: 35px;
}
.top-margin-10 {
  margin-top: 10px;
}
.bottom-margin-10 {
  margin-bottom: 10px;
}
.top-margin-20 {
  margin-top: 20px;
}
.bottom-margin-20 {
  margin-bottom: 20px;
}
.top-margin-25 {
  margin-top: 25px;
}
.bottom-margin-25 {
  margin-bottom: 25px;
}
.top-margin-30 {
  margin-top: 30px;
}
.bottom-margin-30 {
  margin-bottom: 30px;
}
.top-margin-35 {
  margin-top: 35px;
}
.bottom-margin-35 {
  margin-bottom: 35px;
}
.button-spacer-right {
  margin-right: 15px;
}
.image-foreground {
  padding: 70px;
  text-align: center;
  min-width: 100%;
  height: 800px;
  position: absolute;
  top: 65px;
  left: 0;
}
.image-foreground p {
  font-size: 25px;
  margin-bottom: 15px;
}
.image-foreground h1 {
  line-height: 110%;
  margin-bottom: 10px;
  font-size: 50px;
}
.image-container {
  max-width: 100%;
  height: 400px;
  object-fit: cover;
}
.image-background {
  max-width: 100%;
  height: 400px;
  opacity: 40%;
  position: absolute;
  object-fit: cover;
}
.fadein img {
  opacity: 0;
  animation-name: fade;
  animation-duration: 80s;
  animation-iteration-count: infinite;
  position: absolute;
  left: 0;
  right: 0;
}
.fadein img:nth-child(1) {
  animation-delay: 0s;
}
.fadein img:nth-child(2) {
  animation-delay: 16s;
}
.fadein img:nth-child(3) {
  animation-delay: 32s;
}
.fadein img:nth-child(4) {
  animation-delay: 48s;
}
.fadein img:nth-child(5) {
  animation-delay: 64s;
}
@media only screen and (min-width: 768px) {
  .image-container {
    height: 600px;
  }
  .image-background {
    min-width: 100%;
    height: 600px;
  }
  .image-background p {
    font-size: 20px;
  }
  .image-background h1 {
    font-size: 33px;
  }
}
/*# sourceMappingURL=image-header.component-KGXMHDVJ.css.map */
